(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-spring-sale-price"] && !Shopify.designMode) return;
  try {
    (()=>{
  const start=Date.parse('2026-10-21T08:56:28Z'),end=Date.parse('2026-11-21T13:00:00Z');
  let timer;
  function syncSpringSale(){
    const now=Date.now(),active=now>=start&&now<end;
    document.querySelectorAll('[data-fs-spring-price]').forEach(price=>{
      const show=active&&price.dataset.saleEligible==='true';
      price.querySelector('[data-sale-regular]').hidden=show;
      price.querySelector('[data-sale-offer]').hidden=!show;
    });
    clearTimeout(timer);
    const next=now<start?start:now<end?end:0;
    if(next)timer=setTimeout(syncSpringSale,Math.min(next-now+10,2147483647));
  }
  syncSpringSale();
  document.addEventListener('shopify:section:load',syncSpringSale);
  document.addEventListener('visibilitychange',syncSpringSale);
  window.addEventListener('pageshow',syncSpringSale);
})();
  } catch(e) { console.error(e); }
})();

})();
